<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
  >
    <el-form
      ref="form"
      size="small"
      label-width="100px"
      :rules="rules"
      :model="model"
      class="fix-width"
      inline
    >
      <el-form-item
        label="拆卸基地"
        prop="base_id"
        v-if="!model.only_add_record"
      >
        <BaseSelect v-model="model.base_id" :filterBlank="true"></BaseSelect>
      </el-form-item>
      <el-form-item
        label="拆卸日期"
        prop="operate_date"
        v-if="!model.only_add_record"
      >
        <el-date-picker
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.operate_date"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <template v-if="model.only_add_record">
        <el-form-item label="使用日期" prop="used_date">
          <el-date-picker
            :picker-options="{
              disabledDate(time) {
                return time.getTime() > Date.now()
              },
            }"
            v-model="model.used_date"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="井号" prop="drill_well_id" v-if="category == 2">
          <DrillWellSelect
            v-model="model.drill_well_id"
            @info="model.used_extra = getRecordExtrainfo($event)"
          ></DrillWellSelect>
        </el-form-item>
        <el-form-item
          v-else
          :label="param.label"
          v-for="param in model.used_extra"
          :key="param.key"
        >
          <el-input v-model="param.value"></el-input>
        </el-form-item>
        <el-form-item
          label="工作时长"
          :prop="model.only_add_record ? 'used_hour' : ''"
        >
          <el-input-number v-model="model.used_hour"></el-input-number>
        </el-form-item>
      </template>
      <el-form-item
        :label="!model.only_add_record ? '拆检情况' : '备注'"
        class="long"
      >
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="图片" class="long">
        <el-upload
          class="upload-small"
          multiple
          :action="actionUrl"
          :headers="uploadHeader"
          :on-error="handleUploadError"
          :on-remove="handleOnRemove"
          :on-success="handleOnSuccess"
          list-type="picture-card"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="视频" class="long">
        <VideoUploader v-model="model.videos" v-if="visible"></VideoUploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productDisassemble, productItemDisassemble } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/index'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    category: Number,
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },

  computed: {
    dialogTitle() {
      if (this.model.only_add_record) {
        return '添加使用记录'
      } else {
        return this.model.type == 1 ? '成品拆卸' : '配件拆卸'
      }
    },
  },
  data() {
    return {
      actionUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      submiting: false,
      rules: {
        operate_date: [
          { required: true, message: '请选择拆卸日期', trigger: 'change' },
        ],
        used_date: [
          { required: true, message: '请选择使用日期', trigger: 'change' },
        ],
        base_id: [
          { required: true, message: '请选择拆卸基地', trigger: 'change' },
        ],
        used_hour: [
          { required: true, message: '工作时长不能为空', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '工作时长不能为0',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res
          if (this.model.type == 1) {
            res = await productDisassemble(this.model)
          } else {
            let data = this.clone(this.model)
            delete data.used_date
            res = await productItemDisassemble(data)
          }
          if (res.code == 0) {
            this.$emit('updated', res.data)
            this.visible = false
          }
          this.submiting = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    handleOnRemove(file) {
      let index = this.model.imgs.indexOf(file.response.data)
      this.model.imgs.splice(index, 1)
    },
    handleOnSuccess(res, file) {
      this.model.imgs.push(res.data)
    },
  },
}
</script>
